import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fastest-option-badge',
  templateUrl: './fastest-option-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FastestOptionBadgeComponent {}
